module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('LoadingMid', {
    attrs: {
      "loading-show": _vm.midLoadingShow,
      "text": _vm.midLoadingText
    }
  }), _vm._v(" "), _c('Toast', {
    attrs: {
      "toast-show": _vm.toastShow,
      "text": _vm.toastText
    }
  }), _vm._v(" "), _c('AddToHome'), _vm._v(" "), _c('Login'), _vm._v(" "), _c('LoginDetail'), _vm._v(" "), _c('div', [_c('form', {
    attrs: {
      "action": _vm.paypalUrl,
      "method": "post",
      "target": "_top",
      "id": "post-form"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id"
    },
    domProps: {
      "value": _vm.postData.button_id
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "custom"
    },
    domProps: {
      "value": _vm.postData.custom
    }
  })])]), _vm._v(" "), (_vm.web_navbar_show) ? _c('nav', [_c('WebTopBar', {
    attrs: {
      "title-name": _vm.navName,
      "user-img": _vm.webNavImg,
      "collect-show": _vm.collectShow,
      "img-show": _vm.navImgShow,
      "account-show": _vm.accountShow
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('main', [_c('router-view')], 1), _vm._v(" "), (_vm.webTabbarShow) ? _c('footer', [_c('div', {
    staticClass: "footer-inner"
  }, [_c('div', {
    staticClass: "tabbar-bottom",
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "left": "0",
      "z-index": "10"
    }
  }, [_c('a', {
    class: {
      active: _vm.tabSeleced == 'follow'
    },
    on: {
      "click": _vm.followClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'follow'),
      expression: "tabSeleced != 'follow'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_followers@3x.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'follow'),
      expression: "tabSeleced == 'follow'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_followers_selceted@3x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Followers")])]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabSeleced == 'like'
    },
    on: {
      "click": _vm.likeClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'like'),
      expression: "tabSeleced != 'like'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_like@3x.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'like'),
      expression: "tabSeleced == 'like'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_like_selceted@3x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Likes")])]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabSeleced == 'subscription'
    },
    on: {
      "click": _vm.subscriptionClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'subscription'),
      expression: "tabSeleced != 'subscription'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_sub@3x.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'subscription'),
      expression: "tabSeleced == 'subscription'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_sub_selceted@3x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Subscriptions")]), _vm._v(" "), _c('i', [_vm._v("NEW")])]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabSeleced == 'more'
    },
    on: {
      "click": _vm.moreClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'more'),
      expression: "tabSeleced != 'more'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_more@3x.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'more'),
      expression: "tabSeleced == 'more'"
    }],
    attrs: {
      "src": require("./assets/icon/image_tabar_more_selected@3x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("More")])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-169daf8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 265
// module chunks = 18